/*
 * QR Page
 */
if (document.querySelector("body")?.classList.contains("page-qr")) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let lotId = urlParams.get("lot_id");
  let cookie = sessionStorage.getItem("traceability_lot_id");
  let submitted = sessionStorage.getItem("traceability_lot_id_submitted");

  if (submitted) {
    if (lotId && cookie) {
      const lastChar = lotId[lotId.length - 1];

      if (lastChar.toLowerCase() != lastChar.toUpperCase()) {
        lotId = lotId.slice(0, -1);
      }

      //LotID param and LotID cookie are the same
      //Redirect to landing with LotID param same as cookie
      if (lotId == sessionStorage.getItem("traceability_lot_id")) {
        window.location.href = "/?lot_id=" + cookie;
      } else {
        //LotID param and LotID cookie are different
        //Overwrite LotID cookie and remove submitted cookie
        sessionStorage.setItem("traceability_lot_id", lotId);
        sessionStorage.removeItem("traceability_lot_id_submitted");
      }
    } else if (cookie) {
      window.location.href = "/?lot_id=" + cookie;
    } else if (lotId) {
      const lastChar = lotId[lotId.length - 1];

      if (lastChar.toLowerCase() != lastChar.toUpperCase()) {
        lotId = lotId.slice(0, -1);
      }
      sessionStorage.setItem("traceability_lot_id", lotId);
    } else {
      window.location.href = "/?lot_id=" + cookie;
    }
  } else {
    if (lotId) {
      const lastChar = lotId[lotId.length - 1];

      if (lastChar.toLowerCase() != lastChar.toUpperCase()) {
        lotId = lotId.slice(0, -1);
      }
      sessionStorage.setItem("traceability_lot_id", lotId);
    }
  }
}

/*
 * B2B QR Page
 */

if (document.querySelector("body")?.classList.contains("page-qr-b2b")) {
  //Store lot_id GET param in sessionStorage
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let lotId = urlParams.get("lot_id");

  if (lotId) {
    //Change button HREF depending on lot_id GET param
    const button = document.querySelector(
      ".google-form-url a"
    ) as HTMLLinkElement;

    if (button && lotId) {
      const lotIdToLink = {
        "APL05-0002a": "https://forms.gle/ByzbXYTpudySdYT66",
        "APL05-0002b": "https://forms.gle/w1puLbajeD4UU7Lr9",
        "APL05-0002c": "https://forms.gle/FnSRkQcjMLq5XnWN9",
        "STR05-0002a": "https://forms.gle/cNME3svttWnmCiaY9",
        "STR05-0002b": "https://forms.gle/wBUe6cHjW3fGdvd88",
        "STR05-0002c": "https://forms.gle/yymmx71Mr613ksDV8",
        "JAF05-0002a": "https://forms.gle/UMVpM1knT1Cr2KLv7",
        "JAF05-0002b": "https://forms.gle/CW17AccFFoSzziU48",
        "JAF05-0002c": "https://forms.gle/JidLhYyyZMXrYQfu9",
        "SPN05-0002a": "https://forms.gle/Xy7CLsLxjh5o32Z26",
        "SPN05-0002b": "https://forms.gle/TGakEpRxX1F27S5R8",
        "SPN05-0002c": "https://forms.gle/bLTefWCLC1qKGkn49",
      };

      const newLink = lotIdToLink[lotId];

      button.href = newLink;
    }

    const lastChar = lotId[lotId.length - 1];

    if (lastChar.toLowerCase() != lastChar.toUpperCase()) {
      lotId = lotId.slice(0, -1);
    }
    sessionStorage.setItem("traceability_lot_id", lotId);
  }
}
